<template>
  <CFooter>
    <div class="mx-auto">Copyright &copy; 2022 Lavie</div>
  </CFooter>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>
